export const FETCH_ORGANISATION_PENSION_SCHEMES =
  'pensionScheme/FETCH_ORGANISATION_PENSION_SCHEMES';
export const FETCH_FILTER_PENSION_SCHEMES =
  'pensionScheme/FETCH_FILTER_PENSION_SCHEMES';
export const ADD_PENSION_SCHEME = 'pensionScheme/ADD_PENSION_SCHEME';
export const ADD_NEW_REPORTING_PERIOD =
  'pensionScheme/ADD_NEW_REPORTING_PERIOD';
export const UPDATE_PENSION_SCHEME = 'pensionScheme/UPDATE_PENSION_SCHEME';
export const DELETE_PENSION_SCHEME = 'pensionScheme/DELETE_PENSION_SCHEME';
export const ADD_SERVICE_COST = 'pensionScheme/ADD_SERVICE_COST';
export const DELETE_SERVICE_COST = 'pensionScheme/DELETE_SERVICE_COST';
export const UPDATE_SUBFUND_PROPORTIONS =
  'pensionScheme/UPDATE_SUBFUND_PROPORTIONS';
